import { RootState } from '../index.ts';

export const selectInitialCallHasBeenMade = (state: RootState) => state.summary.initialCallHasBeenMade;
export const selectPensions = (state: RootState) => state.summary.pensions;
export const selectContributions = (state: RootState) => state.summary.contributions;
export const selectDebts = (state: RootState) => state.summary.debts;
export const selectInsuranceHistorySummary = (state: RootState) => state.summary.insuranceHistorySummary;
